export enum LanguagesEnum {
  'en-GB' = 'en-GB',
  'en-US' = 'en-US',
  'nl-NL' = 'nl-NL',
  'nl-BE' = 'nl-BE',
  'fr-FR' = 'fr-FR'
}

export type LanguagesEnumType = keyof typeof LanguagesEnum;
